import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Bodega/bodega';
import AreaCrear from './AreaCrear';

const mstp = state => {
    return {...state.bodega}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(AreaCrear)
